import { atom } from "recoil";

export const promotionAtom = atom({
  key: "promotionCompanyId",
  default: {
    KTCompanyId: 27,
    SKBCompanyId: 28,
  },
});
